import { getDocs, collection, doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from '../../../firebase/config';

export type Manager = {
    id: string;
    name: string;
    mobile?: string;
    email?: string;
    type?: string;
    createdAt?: any;
    updatedAt?: any;
};

export async function fetchManagers(bankId: string): Promise<Manager[]> {
    const mgrSnap = await getDocs(collection(db, "banks", bankId, "managers"));
    const managerList: Manager[] = mgrSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    } as Manager));

    // Sort by name
    managerList.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        return nameA.localeCompare(nameB);
    });

    console.log('Fetched Managers:', managerList.length);

    return managerList;
}

export async function updateManager(bankId: string, managerId: string, data: Partial<Manager>): Promise<void> {
    const managerRef = doc(db, "banks", bankId, "managers", managerId);
    const updateData = { ...data, updatedAt: new Date() };
    await updateDoc(managerRef, updateData);
}

export async function fetchManagerBankId(uid: string, isBankUser: boolean = false): Promise<string | null> {
    if (isBankUser) {
        // For bank users, check if uid is a bank document ID or if there's a bank with userId == uid
        const directBank = await getDoc(doc(db, "banks", uid));
        if (directBank.exists()) {
            return uid;
        }
        // Try query by userId field
        const banksSnap = await getDocs(collection(db, "banks"));
        for (const bankDoc of banksSnap.docs) {
            const bankData = bankDoc.data();
            if (bankData.userId === uid) {
                return bankDoc.id;
            }
        }
        return null;
    } else {
        // For PSO users, find which bank has this PSO
        const banksSnap = await getDocs(collection(db, "banks"));
        for (const bankDoc of banksSnap.docs) {
            const posDocRef = doc(db, "banks", bankDoc.id, "pos", uid);
            const posDoc = await getDoc(posDocRef);
            if (posDoc.exists()) {
                return bankDoc.id;
            }
        }
        return null;
    }
}

